import React from 'react';
import { Link } from 'react-router-dom';
import './LogoFlavor.css';
import FadeInText from './FadeInText';
import LogoDark from './assets/seifdune-logo-dark.svg';

const HOME_TEXT = 'Seifdune is a global investment firm building and capitalizing category-defining technology businesses.';
const PORTFOLIO_TEXT = 'Concentrated investing in the next generation of world-class infrastructure businesses.';

const LogoFlavor = ({ transitionClass, isTextVisible, logoScale = 100 }) => {
  const displayText = transitionClass === 'home' ? HOME_TEXT : PORTFOLIO_TEXT;
  const logoDestination = transitionClass === 'home' ? '/portfolio' : '/';
  const logoLabel = transitionClass === 'home' ? 'View infrastructure portfolio' : 'Return to Seifdune home';
  const logoSize = `${60 * (logoScale / 100)}px`;

  return (
    <div className={`logo-flavor logo-flavor--${transitionClass}`}>
      <Link
        to={logoDestination}
        className={`logo-flavor__link logo-flavor__link--${transitionClass}`}
        aria-label={logoLabel}
        style={{ width: logoSize, height: logoSize }}
      >
        <img src={LogoDark} alt="Seifdune" />
      </Link>
      <FadeInText
        text={displayText}
        layout={transitionClass}
        isVisible={isTextVisible}
        keepLastWordsTogether
      />
    </div>
  );
};

export default LogoFlavor;
